/**
 * @generated SignedSource<<a12b4cf37100b434fbfe82661c2922fe>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type DeleteCompanyContactInput = {
  companyId?: string | null;
  contactType?: string | null;
  csrfToken?: string | null;
  socketClientId?: string | null;
  clientMutationId?: string | null;
};
export type DeleteCompanyContactMutation$variables = {
  input: DeleteCompanyContactInput;
};
export type DeleteCompanyContactMutation$data = {
  readonly deleteCompanyContact: {
    readonly deletedContactId: string | null;
  } | null;
};
export type DeleteCompanyContactMutation = {
  variables: DeleteCompanyContactMutation$variables;
  response: DeleteCompanyContactMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "DeleteCompanyContactPayload",
    "kind": "LinkedField",
    "name": "deleteCompanyContact",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "deletedContactId",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "DeleteCompanyContactMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "DeleteCompanyContactMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "cac2feb55f3095c49966a785f59dd700",
    "id": null,
    "metadata": {},
    "name": "DeleteCompanyContactMutation",
    "operationKind": "mutation",
    "text": "mutation DeleteCompanyContactMutation(\n  $input: DeleteCompanyContactInput!\n) {\n  deleteCompanyContact(input: $input) {\n    deletedContactId\n  }\n}\n"
  }
};
})();

(node as any).hash = "3a131c5ca3f753d60376bca9ffc0096c";

export default node;
